<template>
  <div class="steps-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'step-body'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";

.steps-body {
  background-color: $white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 2px 2px rgba($secondary,0.6);
  @include mq-up(md) {
    border-radius: 10px;
    padding: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/StepBody.vue